<template>
    <div class="w-full">
        <ContentRendererMarkdown :value="data">
            <template #empty>
                <p>No content found.</p>
            </template>
        </ContentRendererMarkdown>
    </div>
</template>
<script setup>
const props = defineProps({
    dir: String,
    url: String
})
const { data } = await useAsyncData('article', () => queryContent('/developers/templates/' + props.dir + '/_readmes/' + props.url).where({ _partial: true }).findOne())
</script>

<style scoped>
::v-deep(p[align="left"]) {
    display: none;
}
</style>
